import React, { useRef, useState } from "react"
import Select from 'react-select';
import { useOnClickOutside } from "../../hooks";
import { useDispatch, useSelector } from "react-redux";
import { setActiveModalAction } from "../../action";
import { withRouter  } from 'react-router-dom';
import { modalsSelector } from "../../selectors";
import Input from "../../components/utils/Input";
import swal from 'sweetalert';
import { requestAtol } from "../../action/cassa";
import { setFiscalDataOrder } from "../../action/orders";

const optionsCorrectionType = [
    {label: 'Самостоятельно', value: 'self'},
    {label: 'По предписанию.', value: 'instruction'}
];

const CorrectionModal = () => {
    const ref = useRef();
    const dispatch = useDispatch();
    const data = useSelector(modalsSelector).correctionModal;
    const [correctionType, setCorrectionType] = useState({label: 'Самостоятельно', value: 'self'});
    const [correctionNumber, setCorrectionNumber] = useState(null);

    const onClose = () => dispatch(setActiveModalAction({ field: 'correctionModal', value: null }));
    
    useOnClickOutside(ref, onClose);

    const onSubmit = async () => {
        if (correctionType === 'self') setCorrectionNumber(null);

        const requestData = {
            ...data,
            correctionType: correctionType.value,
            correctionNumber: correctionNumber ? String(correctionNumber) : null
        };

        const correction = await dispatch(requestAtol(requestData));

        if (correction.error) {
            return swal({
                title: "Ошибка коррекции",
                text: `${correction.error.code ? `Код ошибки: ${correction.error.code}` : ''}${correction.error.description ? `, ${correction.error.description}` : ''}`,
                icon: "error",
                button: "Ок",
            }).then(() => {
                onClose();
            });
        }

        if (correction && !correction.error) {
            const result = {
                id: data.order.id,
                fiscalUUID: correction.fiscalUUID,
                fiscalized: true
            };

            dispatch(setFiscalDataOrder(result));

            return swal({
                title: "Коррекция проведена",
                icon: "success",
                button: "Ок",
            }).then(() => {
                onClose();
            });
        }        
    }

    const isValid = () => {
        if (!data || !data.order || !correctionType) return false;
        if (correctionType.value === 'instruction' && !correctionNumber) return false;
        return true;
    }

    return(
        <form>
            <div className="modal fade show" style={{ display: 'block' }}>
                <div className="modal-dialog modal-lg modal-dialog-scrollable">
                    <div ref={ref} className="modal-content" style={{ minHeight: '350px' }}>
                        <div className="modal-header">
                            <h5 className="modal-title"> Коррекция чека №{data.order.id} </h5>
                            <button onClick={onClose} type="button" className="close"></button>
                        </div>
                        <div className="modal-body">
                            <div className="form-group" style={{ marginBottom: '0.5rem' }}>
                                <div style={{ marginBottom: '0.5rem' }}>Тип *</div>                               
                                <Select
                                    placeholder='Тип'
                                    value={correctionType}
                                    onChange={setCorrectionType}
                                    options={optionsCorrectionType}
                                    noOptionsMessage={() => 'Нет типов'}
                                />
                            </div>
                            {correctionType.value === 'instruction' &&
                                <Input
                                label='Номер предписания налогового органа'
                                required={true}
                                onChange={(e) => setCorrectionNumber(e.target.value)}
                                value={correctionNumber}
                                placeholder='Номер предписания налогового органа'
                                />
                            }
                        </div>                        
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" onClick={onClose}>Отмена</button>
                            <button disabled={!isValid()} type="button" onClick={onSubmit} className='btn btn-primary'>Коррекция</button>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    )
}

export default withRouter(CorrectionModal);